import { render } from "./TextBlockWithImageGrid.vue?vue&type=template&id=6634a2e4"
import script from "./TextBlockWithImageGrid.vue?vue&type=script&lang=js"
export * from "./TextBlockWithImageGrid.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__